import { Routes } from '@angular/router';
import { FaceidLoginComponent } from './faceid-login/faceid-login.component';
import { PushNotificationEnableComponent } from './push-notification-enable/push-notification-enable.component';
import { WelcomeUserComponent } from './welcome-user/welcome-user.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { SetupPasswordComponent } from './setup-password/setup-password.component';
import { SetupPasswordConfirmationComponent } from './setup-password-confirmation/setup-password-confirmation.component';
import { AddProductComponent } from './add-product/add-product.component';
import { StarterComponent } from './starter/starter.component';
import { PageAppStartComponent } from './page-app-start/page.component';
import { ResultPageComponent } from './common/components/result-page/result-page.component';
import { ResultComponent } from './common/components/result/result.component';
import { FaqComponent } from './faq/faq.component';
import { SecurityTipsComponent } from './security-tips/security-tips.component';
import { AboutUsComponent } from './about-us/about-us.component';
import {TapnpayTncFormComponent} from './tap-n-pay/tapnpay-tnc-form/tapnpay-tnc-form.component';
import {TapnpayconfirmationComponent} from './tap-n-pay/tapnpayconfirmation/tapnpayconfirmation.component';
import {TapnpayNfcInstFormComponent} from './tap-n-pay/tapnpay-nfc-inst-form/tapnpay-nfc-inst-form.component';
import {TapnpayTxnsuccessFormComponent} from './tap-n-pay/tapnpay-txnsuccess-form/tapnpay-txnsuccess-form.component';
export var welcomeComponentRoutes: Routes = [
  {
    path: '',
    component: StarterComponent,
  },
  {
    path: 'appnavigator',
    component: PageAppStartComponent,
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'faceidlogin',
    component: FaceidLoginComponent,
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'welcomeuser',
    component: WelcomeUserComponent,
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'pushConfirmation',
    component: PushNotificationEnableComponent,
    data: { animation: 'fadeInAnimation' },
  }
];

export var stagingComponentRoutes: Routes = [
  {
    path: 'contactUs',
    component: ContactUsComponent,
  },
  {
    path: 'faq',
    component: FaqComponent,
  },
  {
    path: 'security',
    component: SecurityTipsComponent,
  },
  {
    path: 'about',
    component: AboutUsComponent,
  },
  {
    path: 'setupPassword',
    component: SetupPasswordComponent,
  },
  {
    path: 'setupPasswordConfirmation',
    component: SetupPasswordConfirmationComponent,
  },
];

/** Home module childs */
export var componentRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('src/app/OverviewUI/OverviewUI.module').then((m) => m.OverviewUIModule),
  },
  {
    path: 'overview',
    loadChildren: () => import('src/app/OverviewUI/OverviewUI.module').then((m) => m.OverviewUIModule),
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'tapnpaytnc',
    component: TapnpayTncFormComponent, 
  },
  {
    path: 'tapnpayconfirmation',
    component: TapnpayconfirmationComponent, 
  }, 
  {
    path: 'tapnpaynfcinstruction',
    component: TapnpayNfcInstFormComponent, 
  },
  {
    path: 'tapnpaytxnsuccess',
    component: TapnpayTxnsuccessFormComponent, 
  },
  // {
  //   path: 'transactions',
  //   loadChildren: () => import('src/app/Accounts/Accounts.module').then((m) => m.AccountsModule),
  //   data: { animation: 'fadeInAnimation' },
  // },
  {
    path: 'family-banking',
    loadChildren: () =>
      import('src/app/family-banking-ui/family-banking-ui.module').then((m) => m.FamilyBankingUiModule)
  },
  {
    path: 'mailbox',
    loadChildren: () => import('src/app/mailbox/mailbox-home/mailbox-home.module').then((m) => m.MailBoxHomeModule)
  },
  // {
  //   path: 'transfers',
  //   loadChildren: () => import('src/app/retail/transfers-ui/transfers-ui.module').then((m) => m.TransfersUiModule)
  // },
  {
    path: 'transfers',
    loadChildren: () => import('src/app/transfers/transfers-home/transfers-home.module').then((m) => m.TransfersHomeModule),
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'pfm',
    loadChildren: () => import('src/app/pfm/pfm-home/pfm-home.module').then((m) => m.PfmHomeModule),
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'payments',
    loadChildren: () => import('src/app/bill-payments/bill-payments-home/bill-payments-home.module').then((m) => m.BillPaymentsHomeModule),
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'bill-payments',
    loadChildren: () => import('src/app/bill-payments/bill-payments-home/bill-payments-home.module').then((m) => m.BillPaymentsHomeModule),
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'transactionInfo',
    loadChildren: () => import('src/app/retail/accounts/transaction-info/transaction-info.module').then((m) => m.TransactionInfoModule)
  },
  {
    path: 'deposit-details',
    loadChildren: () => import('src/app/retail/transactions/deposits/deposit-details/deposit-details.module').then((m) => m.DepositDetailsModule),
  },
  {
    path: 'service-requests',
    loadChildren: () => import('src/app/service-request/service-request-home/service-request-home.module').then((m) => m.ServiceRequestHomeModule),
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'settings',
    loadChildren: () => import('src/app/retail/settings-ui/settings-ui.module').then((m) => m.SettingsUiModule)
  },
  {
    path: 'depositDetailView',
    loadChildren: () =>
      import('src/app/depositDetailView/depositDetailView.module').then(
        (m) => m.depositDetailViewModule
      ),
  },
  /*{
    path: 'loans',
    loadChildren: () =>
      import('src/app/loans/loans.module').then((m) => m.LoansModule),
  },*/
  {
    path: 'cards',
    loadChildren: () => import('src/app/cards/cards-home/cards-home.module').then((m) => m.CardsHomeModule),
  },
  {
    path: 'transactions',
    loadChildren: () => import('src/app/transactions/transactions-home/transactions-home.module').then((m) => m.TransactionsHomeModule),
  },
  {
    path: 'addProduct',
    component: AddProductComponent,
  },
  {
    path: 'mobile-topup',
    loadChildren: () => import('src/app/mobile-topup/mobile-topup-home/mobile-topup-home.module').then((m) => m.MobileTopupHomeModule),
    data: { animation: 'fadeInAnimation' },
  },
  {
    path: 'sr-request',
    loadChildren: () => import('src/app/retail/service-request-ui/service-request-ui.module').then((m) => m.ServiceRequestUiModule)
  },
  {
    path: 'tools',
    loadChildren: () => import('src/app/tools/tools-home/tools-home.module').then((m) => m.ToolsHomeModule),
  },
];

export var accountsComponentRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('src/app/AccountsLanding/AccountsLanding.module').then(
        (m) => m.AccountsLandingModule
      ),
  },
  {
    path: "account-details",
    loadChildren: () => import('src/app/retail/accounts/account-details/account-details.module').then(m => m.AccountDetailsModule)
  },
  {
    path: "open-new-savings-account",
    loadChildren: () => import('src/app/retail/accounts/open-new-savings-account/open-new-savings-account.module').then(m => m.OpenNewSavingsAccountModule)
  },
  {
    path: "open-new-current-account",
    loadChildren: () => import('src/app/retail/accounts/open-new-current-account/open-new-current-account.module').then(m => m.OpenNewCurrentAccountModule)
  },
  {
    path: "request-cheque-book",
    loadChildren: () => import('src/app/retail/accounts/request-cheque-book/request-cheque-book.module').then(m => m.RequestChequeBookModule)
  },
  {
    path: "open-new-casa-account",
    loadChildren: () => import('src/app/retail/accounts/open-new-casa-account/open-new-casa-account.module').then(m => m.OpenNewCasaAccountModule)
  },
  {
    path: "cheque-status-inquiry",
    loadChildren: () => import('src/app/retail/accounts/cheque-status-inquiry/cheque-status-inquiry.module').then(m => m.ChequeStatusInquiryModule)
  },
  {
    path: "request-dd",
    loadChildren: () => import('src/app/retail/accounts/request-dd/request-dd.module').then(m => m.RequestDdModule)
  },
  {
    path: "request-account-statement",
    loadChildren: () => import('src/app/retail/accounts/request-account-statement/request-account-statement.module').then(m => m.RequestAccountStatementModule)
  },
  {
    path: 'result',
    component: ResultPageComponent
  },
  {
    path: 'result-page',
    component: ResultComponent
  },
  {
    path: 'mutual-funds',
    loadChildren: () => import('src/app/retail/mutual-funds/mutual-funds.module').then(m => m.MutualFundsModule)
  },
  {
    path: 'deposits',
    loadChildren: () => import('src/app/retail/deposits/deposits.module').then(m => m.DepositsModule)
  }
];

export var preloginComponentRoutes: Routes = [
  {
    path: "",
    loadChildren: () => import('src/app/pre-login/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'mpin-login',
    loadChildren: () =>
      import('src/app/pre-login/mpin-login/mpin-login.module').then((m) => m.MpinLoginModule),
  },
  {
    path: 'biometric-login',
    loadChildren: () =>
      import('src/app/pre-login/biometric-login/biometric-login.module').then((m) => m.BiometricLoginModule),
  },
  {
    path: 'otp-auth',
    loadChildren: () =>
      import('src/app/pre-login/otp-page/otp-page.module').then(
        (m) => m.OtpPageModule
      ),
  },
  {
    path: 'setMPIN',
    loadChildren: () =>
      import('src/app/pre-login/set-mpin/set-mpin.module').then((m) => m.SetMpinModule),
  },
  {
    path: 'confirmMPIN',
    loadChildren: () =>
      import('src/app/pre-login/confirm-mpin/confirm-mpin.module').then((m) => m.ConfirmMpinModule),
  },
  {
    path: 'identity-yourself',
    loadChildren: () =>
      import('src/app/pre-login/identity-yourself/identity-yourself.module').then((m) => m.IdentityYourSelfModule),
  },
  {
    path: 'reset-password',
    loadChildren: () =>
      import('src/app/pre-login/reset-password/reset-password.module').then((m) => m.ResetPasswordModule),
  },
  {
    path: 'trouble-login',
    loadChildren: () =>
      import('src/app/pre-login/trouble-login/trouble-login.module').then((m) => m.TroubleLoginModule),
  },
  {
    path: 'mpin-login',
    loadChildren: () =>
      import('src/app/pre-login/mpin-login/mpin-login.module').then((m) => m.MpinLoginModule),
  },
  {
    path: 'enable-device-auth',
    loadChildren: () =>
      import('src/app/pre-login/register-face-id/register-face-id.module').then(
        (m) => m.RegisterFaceIdModule
      ),
  },
  {
    path: 'result',
    loadChildren: () =>
      import('src/app/pre-login/pre-login-result-page/pre-login-result-page.module').then((m) => m.PreLoginResultModule),
  },
  {
    path: 'result-page',
    component: ResultComponent
  },

];

export var loanComponentRoutes: Routes = [
  {
    path: 'repayment-schedule',
    loadChildren: () =>
      import(
        'src/app/retail/loans/repayment-schedule/repayment-schedule.module'
      ).then((m) => m.RepaymentScheduleModule),
  },
  {
    path: 'disbursement-schedule',
    loadChildren: () =>
      import(
        'src/app/retail/loans/disbursement-schedule/disbursement-schedule.module'
      ).then((m) => m.DisbursementScheduleModule),
  },
  {
    path: 'loan-closure-simulation',
    loadChildren: () =>
      import(
        'src/app/loan-closure-simulation/loan-closure-simulation.module'
      ).then((m) => m.LoanClosureSimulationModule),
  },
];

export class AppRoutingModule {}
